// extracted by mini-css-extract-plugin
module.exports = {"card":"RmdashboardCard-module--card--1k0mO"};